.settings {
  display: flex;
  flex-direction: column;
  gap: 18px;
}

.title {
  font-size: 28px;
}

/* One column on a phone, the profile beside the clinicians on a desktop. */
.columns {
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  gap: 18px;
  align-items: start;
}

@media (min-width: 720px) {
  .columns {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

.column {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 12px;
}

.column > section {
  align-self: stretch;
}
